import {VerificationGetResponse, VerificationGetRequest, ErrorSa } from "../models";
import { useHttp } from ".";
import { Observable } from "rxjs";

export type IVerificationsProxy = {
	working: boolean;
	error: ErrorSa | null;
	get: (verificationGetRequest: VerificationGetRequest) => Observable<VerificationGetResponse>;
};

export const useVerificationsProxy = (): IVerificationsProxy => {
	const http = useHttp();

	const path = "verifications";

	const get = (request: VerificationGetRequest) => {
		return http.get<VerificationGetResponse>(path, request, (data: any) => data );
	};

	return {
		working: http.working,
		error: http.error,
		get,
	};
};
